import { CapabilityRegistry } from '@trimble/web3d';
import type { CreateObjectLinkRequest } from '@data-access/connect/tc-tcps';
import {
  getSelectedObjectLinkData as getSharedSelectedObjectLinkData,
  getSelectedSourceIds as getSharedSelectedSourceIds,
  hasModelObjectSelection as hasSharedModelObjectSelection,
  selectLinkedObjects as selectSharedLinkedObjects,
  type CapabilityPane,
  type FileFolderDataState,
} from '@trimble/tc-issue-management-web3d-utilities';
import { is3DPane } from './issue-marker-utils';

export type { FileFolderDataState };

const isMobileMapping3DPane = (pane: CapabilityPane): boolean =>
  is3DPane(pane as Parameters<typeof is3DPane>[0]);

export function hasModelObjectSelection(registry: CapabilityRegistry): boolean {
  return hasSharedModelObjectSelection(registry, {
    isPaneEligible: isMobileMapping3DPane,
  });
}

export async function getSelectedObjectLinkData(
  registry: CapabilityRegistry,
  issueId: string,
  contextId: string,
  dataState: FileFolderDataState
): Promise<CreateObjectLinkRequest | null> {
  return await getSharedSelectedObjectLinkData(
    registry,
    issueId,
    contextId,
    dataState,
    { isPaneEligible: isMobileMapping3DPane }
  );
}

export async function selectLinkedObjects(
  registry: CapabilityRegistry,
  elements: ReadonlyArray<{
    readonly versionId: string;
    readonly sourceId: string;
  }>,
  dataState?: FileFolderDataState
): Promise<boolean> {
  return await selectSharedLinkedObjects(registry, elements, dataState, {
    isPaneEligible: isMobileMapping3DPane,
  });
}

export async function getSelectedSourceIds(
  registry: CapabilityRegistry
): Promise<string[]> {
  return await getSharedSelectedSourceIds(registry, {
    isPaneEligible: isMobileMapping3DPane,
  });
}
